import Vue from 'vue';
import { getPrazos as dadosPrazos } from '@/resources/ofertasCompra';

const PRAZO_OBJECT = 'PRAZO_OBJECT';
const PRAZO_COLLECTION = 'PRAZO_COLLECTION';
const PRAZOS_UPDATE = 'PRAZOS_UPDATE';

const mutations = {
  [PRAZO_OBJECT](state, data) {
    if (data && typeof data === 'object') {
      state.prazo = data;
      state.prazo.data_de = new Date(state.prazo.data_de);
      state.prazo.data_ate = new Date(state.prazo.data_ate);
    }
  },
  [PRAZO_COLLECTION](state, data) {
    if (data && typeof data === 'object' && data.length) {
      const prazos = data.map(prazo => ({
        id: prazo.id,
        nome: prazo.nome,
        situacao_id: prazo.situacao_id,
        data_de: prazo.data_de !== null ? new Date(prazo.data_de) : '',
        data_ate: prazo.data_ate !== null ? new Date(prazo.data_ate) : '',
        oferta_compra_id: prazo.oferta_compra_id,
        justificativa_suspensao: prazo.justificativa_suspensao,
        prazo_id: prazo.prazo_id,
        observacao: prazo.observacao || null,
        qualification_context: prazo.qualification_context || prazo.qualificationContext || null,
      }));
      state.prazos = prazos;
    }
  },
  [PRAZOS_UPDATE](state, data) {
    const normalizePrazo = prazo => {
      const prazoData = { ...prazo };
      prazoData.data_de =
        prazoData.data_de !== null && prazoData.data_de !== undefined
          ? new Date(prazoData.data_de)
          : '';
      prazoData.data_ate =
        prazoData.data_ate !== null && prazoData.data_ate !== undefined
          ? new Date(prazoData.data_ate)
          : '';
      prazoData.qualification_context =
        prazoData.qualification_context || prazoData.qualificationContext || null;
      return prazoData;
    };

    if (data && Array.isArray(data)) {
      state.prazos = [];
      while (data.length) {
        state.prazos.push(normalizePrazo(data.shift()));
      }
    } else if (data && typeof data === 'object') {
      const prazoData = normalizePrazo(data);

      const index = state.prazos.findIndex(prazoLista => prazoLista.id === prazoData.id);

      if (index > -1) {
        Vue.set(state.prazos, index, { ...state.prazos[index], ...prazoData });
      } else {
        state.prazos.push(prazoData);
      }
    }
  },
};

const actions = {
  setPrazoObject({ commit }, data) {
    commit(PRAZO_OBJECT, data);
  },
  async buscarOfertaCompraPrazos({ commit, rootState }, ofertaCompraId) {
    const { data: dados } = await dadosPrazos(ofertaCompraId);
    const prazos = dados.data;

    if (prazos && Array.isArray(prazos) && prazos.length) {
      const ultimoPrazo = prazos[prazos.length - 1];

      if (ultimoPrazo?.id === 19) {
        const justificativa = rootState.ofertasCompra.ofertaCompra.justificativa_suspensao;
        ultimoPrazo.justificativa_suspensao = justificativa;
        Vue.set(prazos, prazos.length - 1, ultimoPrazo);
      }
    }

    commit(PRAZO_COLLECTION, prazos);
  },
  atualizarPrazos({ commit, rootState }, data) {
    const prazos = data;

    if (prazos && Array.isArray(prazos) && prazos.length) {
      const ultimoPrazo = data[data.length - 1];

      if (ultimoPrazo?.id === 19) {
        const justificativa = rootState.ofertasCompra.ofertaCompra.justificativa_suspensao;
        ultimoPrazo.justificativa_suspensao = justificativa;
        Vue.set(prazos, prazos.length - 1, ultimoPrazo);
      }
    }

    commit(PRAZOS_UPDATE, prazos);
  },
};

const getters = {
  getPrazoObject(state) {
    return state.prazo;
  },
  obterOfertaCompraPrazos(state) {
    return state.prazos;
  },
};

const state = {
  prazo: {},
  prazos: [],
};

export default {
  state,
  mutations,
  actions,
  getters,
};
